import React from 'react'
import { Stack } from '@mui/material'
import Details from '../Incident/Details'
import WelfareDetails from './WelfareDetails'
import Attachments from '../Attachments/Attachments'
import TempReview from '../Review/TempReview'

const WelfareForm = () => {
  return (
    <Stack gap={1}>
      <Details />
      <WelfareDetails />
      <Attachments />
      <TempReview />
    </Stack>
  )
}

export default WelfareForm
